import React from "react";

const Right = () => (
  <svg
    width="16"
    height="44"
    viewBox="0 0 16 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H8L16 22L8 44H0V0Z" fill="white" />
  </svg>
);

export default Right;
